import { useEffect, useState } from 'react';
import { onUpdate, offUpdate, CanonicalUserProfile } from '@updater/identity';

export function useIdentityProfile(): CanonicalUserProfile | null {
  const [profile, setProfile] = useState<CanonicalUserProfile | null>(null);

  useEffect(() => {
    const listener = (p: CanonicalUserProfile) => setProfile(p);
    onUpdate(listener);
    return () => offUpdate(listener);
  }, []);

  return profile;
}
